import React, {useEffect} from "react";
import { Row, Col } from "react-bootstrap";
import GeneralGridItem from "../GeneralGridItem";
import { getAllBrands } from "../../services/BrandService";
import { Link } from "react-router-dom";

import { useSelector, useDispatch } from 'react-redux'
import { updateBrandsWidget } from '../../redux/homePageSlice'

function BrandWidget() {


  const  items  = useSelector((state) => state.homepage.brandsWidget);
  const  languageId  = useSelector((state) => state.homepage.languageId);

  
  const dispatch = useDispatch()

  useEffect(() => {
    getAllBrands(languageId, 1, 4).then(
        (res) => {
          dispatch(updateBrandsWidget(res)) ;
        },
        (failure) => {
          console.error(failure); //expected output: Oopsy...
        }
      );
  }, [languageId, dispatch]);


  return (
    <section className="brand-sec-margin">
      <div className="container">
        <Row className="pb-2">
          <Col md={6} xs={6} className="d-flex flex-column">
            <span className="header-1 home-sec">Brands</span>
            <p className="sub-heading">Shop selected Brands</p>
          </Col>
          <Col md={6} xs={6} className="d-flex align-items-center justify-content-end">
            <Link to={`/brands`} className="big-Link">
              SEE ALL Brands
            </Link>
          </Col>
        </Row>
        <Row className="mobile-grid">
          {items.map((item) => {
            return <GeneralGridItem imgUrl={ item.pictureUrl} key={item.id} totalProducts={item.totalProducts}  name= {item.name} id={item.id}  type="brand" />;
          })}
        </Row>
      </div>
    </section>
  );
}

export default BrandWidget;
